import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'taxObjectTitle',
  standalone: true
})
export class TaxObjectTitlePipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/podatek-lesny-il-1': {
        return 'Las: ';
      }
      case application?.service?.url === '/podatek-lesny-dl-1': {
        return 'Las: ';
      }
      case application?.service?.url === '/podatek-rolny-ir-1': {
        return 'Grunt: ';
      }
      case application?.service?.url === '/podatek-rolny-dr-1': {
        return 'Grunt: ';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-in-1': {
        return 'Nieruchomość: ';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-dn-1': {
        return 'Nieruchomość: ';
      }
      default: {
        return 'Pozycja: ';
      }
    }
  }

}
